import tw, { styled } from "twin.macro"

const FieldContainer = styled.div`
  ${tw`col-span-6 sm:col-span-3`}
`

export default FieldContainer
